import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { useLocation } from 'react-router-dom';

export const usePageVisit = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        const sessionId = session?.access_token || 'anonymous';
        
        await supabase.from('page_visits').insert({
          path: location.pathname,
          user_id: session?.user?.id,
          session_id: sessionId,
          referrer: document.referrer
        });
      } catch (error) {
        console.error('Error tracking page visit:', error);
      }
    };

    trackVisit();
  }, [location.pathname]);
};
